var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('WCampaign',{attrs:{"campaign":_vm.campaignData}}),(_vm.categoryData)?_c('WHomeCategory',{attrs:{"category":_vm.categoryData}}):_vm._e(),(_vm.catalogData)?_c('WCatalog',{staticClass:"home-catalog",attrs:{"id":_vm.id,"catalog":_vm.catalogData}}):_vm._e(),(!_vm.isBandLoading)?_c('Footer'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }